import React, { useState } from 'react';

function PasswordInput({
    label,
    id,
    name,
    value,
    onChange,
    required = false,
    placeholder,
    ariaLabel,
    toggleAriaLabel,
    autoComplete // Add autoComplete prop
}) {
    const [showPassword, setShowPassword] = useState(false);

    const toggleVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <label htmlFor={id} className="form-label">{label}</label>
            <div className="input-group">
                <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id={id}
                    name={name}
                    value={value}
                    onChange={onChange}
                    required={required}
                    placeholder={placeholder}
                    aria-label={ariaLabel || label}
                    autoComplete={autoComplete || "off"} // Apply autoComplete, default to "off" if not specified
                />
                <span className="input-group-text" style={{ cursor: 'pointer' }} aria-label={toggleAriaLabel || "Mostrar u ocultar contraseña"} onClick={toggleVisibility}>
                    <i className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'}`}></i>
                </span>
            </div>
        </>
    );
}

export default PasswordInput;